import { ErrorObservable } from './ErrorObservable';
export var _throw = ErrorObservable.create;
//# sourceMappingURL=throw.js.map